import React from 'react';
import { ScatterChart, CartesianGrid, XAxis, YAxis, Scatter, Tooltip, ResponsiveContainer } from 'recharts';
import { Card } from '@/components/shared/card';
import { OpportunityScore } from '@/types/opportunity';

interface ScatterPlotChartProps {
  data: OpportunityScore[];
}

const CustomTooltip = ({ active, payload }: any) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
      <Card className="bg-white p-3">
        <p className="font-semibold">{data.Name}</p>
        <p>Value: {Math.round(data.valueScore)}%</p>
        <p>Feasibility: {Math.round(data.feasibilityScore)}%</p>
        <p>Score: {Math.round((data.valueScore * 0.6 + data.feasibilityScore * 0.4))}%</p>
      </Card>
    );
  }
  return null;
};

const ScatterPlotChart: React.FC<ScatterPlotChartProps> = ({ data }) => {
  console.log('Rendering ScatterPlotChart with normalized data:', data);
  
  const processedData = data.map(point => ({
    ...point,
    fill: point.quadrantColor
  }));

  // Remove numerical ticks, only keep the center line
  const customTicks = [50];

  return (
    <ResponsiveContainer>
      <ScatterChart margin={{ top: 20, right: 20, bottom: 40, left: 60 }}>
        <CartesianGrid strokeDasharray="3 3" horizontal vertical />
        <XAxis 
          type="number" 
          dataKey="feasibilityScore" 
          name="Feasibility" 
          domain={[0, 100]} 
          label={{ 
            value: 'Less Feasible ←                      → Most Feasible', 
            position: 'bottom',
            offset: 20,
            style: {
              fontWeight: 'bold',
              fontSize: '16px',
              fill: '#000000'
            }
          }}
          ticks={customTicks}
          tickFormatter={() => ''}
        />
        <YAxis 
          type="number" 
          dataKey="valueScore" 
          name="Value" 
          domain={[0, 100]} 
          label={{ 
            value: 'Less Valuable                    ←                    →                    Most Valuable', 
            angle: -90, 
            position: 'center',
            style: {
              fontWeight: 'bold',
              fontSize: '16px',
              fill: '#000000'
            }
          }}
          ticks={customTicks}
          tickFormatter={() => ''}
        />
        <Tooltip content={<CustomTooltip />} />
        <Scatter 
          data={processedData}
          fill="#8884d8"
        />
      </ScatterChart>
    </ResponsiveContainer>
  );
};

export default ScatterPlotChart;